import { FlyerBuilderHeader } from '@/components/molecules/FlyerBuilderHeader'
import { FlyerBuilderSelectTypeSection } from '@/components/molecules/FlyerBuilderSelectTypeSection'
import { getFlyerTemplateFromSitecore } from '@/features/flyer/lib/utils'
import { mockedFlyerTemplate, mockedFlyerTemplateProductLandscape, mockedFlyerTemplateProductPortrait, mockedFlyerTemplateTaticalLandscape } from '@/features/flyer/mocks/flyer-template'
import { FlyerTemplate, Templates } from '@/features/flyer/model/templates'
import { TranslationBundles } from '@/features/sitecore/configs/translation-bundles'

export const FlyerBuilderWrapperFirstStep = async () => {
	const [
		tacticalTemplatesPortrait,
		productTemplatesPortrait,
		tacticalTemplatesLandscape,
		productTemplatesLandscape,
	] = await Promise.all([
		getFlyerTemplateFromSitecore(TranslationBundles.BUILD_YOUR_FLYER_TACTICAL, 'tactical', 'portrait'),
		getFlyerTemplateFromSitecore(TranslationBundles.BUILD_YOUR_FLYER_PRODUCT, 'product', 'portrait'),
		getFlyerTemplateFromSitecore(TranslationBundles.BUILD_YOUR_FLYER_TACTICAL, 'tactical', 'landscape'),
		getFlyerTemplateFromSitecore(TranslationBundles.BUILD_YOUR_FLYER_PRODUCT, 'product', 'landscape'),
	])

	const mockedTacticalPortraitTemplate: FlyerTemplate = {
		flyerType: 'tactical',
		orientation: 'portrait',
		identifier: '0',
		description: 'Template',
		template: mockedFlyerTemplate,
		isSelectable: true,
	}

	const mockedTacticalLandscapeTemplate: FlyerTemplate = {
		flyerType: 'tactical',
		orientation: 'landscape',
		identifier: '0',
		description: 'Template',
		template: mockedFlyerTemplateTaticalLandscape,
		isSelectable: true,
	}

	const mockedProductPortraitTemplate: FlyerTemplate = {
		flyerType: 'product',
		orientation: 'portrait',
		identifier: '0',
		description: 'Template',
		template: mockedFlyerTemplateProductPortrait,
		isSelectable: true,
	}

	const mockedProductLandscapeTemplate: FlyerTemplate = {
		flyerType: 'product',
		orientation: 'landscape',
		identifier: '0',
		description: 'Template',
		template: mockedFlyerTemplateProductLandscape,
		isSelectable: true,
	}

	const templates: Templates = {
		tactical: {
			portrait: tacticalTemplatesPortrait.length > 0 ? tacticalTemplatesPortrait : [mockedTacticalPortraitTemplate],
			landscape: tacticalTemplatesLandscape.length > 0 ? tacticalTemplatesLandscape : [mockedTacticalLandscapeTemplate],
		},
		product: {
			portrait: productTemplatesPortrait.length > 0 ? productTemplatesPortrait : [mockedProductPortraitTemplate],
			landscape: productTemplatesLandscape.length > 0 ? productTemplatesLandscape : [mockedProductLandscapeTemplate],
		},
	}

	return (
		<section className="flex flex-col w-full h-full bg-background">
			<FlyerBuilderHeader />
			<FlyerBuilderSelectTypeSection flyerTemplates={templates} />
		</section>
	)
}
